import gql from 'graphql-tag'

export const EDIT_PROFILE = gql`
    mutation atualizaUsuario($nome: String, $sobrenome: String, $apelido: String){
        atualizaUsuario(nome: $nome, sobrenome: $sobrenome, apelido: $apelido)
    }
`

export const EDIT_PASSWORD = gql`
    mutation atualizaSenha($senha: String!, $novaSenha: String!){
        atualizaSenha(senha: $senha, novaSenha: $novaSenha)
    }
`